"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu() {
  return _react2.default.createElement(
    "g",
    { id: "menu" },
    _react2.default.createElement("path", {
      d: "M0,372.9 L500,372.9 L500,422.1 L0,422.1 L0,372.9 Z M0,225.4 L500,225.4 L500,274.6 L0,274.6 L0,225.4 Z M0,77.9 L500,77.9 L500,127 L0,127 L0,77.9 Z",
      id: "Shape"
    })
  );
};

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Menu.js
// module id = 2968
// module chunks = 4